/*
  Set user context to a header

  Currently only adding UTM metadata
*/
import axios from 'axios';
import { getUserContext } from '../utilities/user';

axios.interceptors.request.use(
  config => {
    try {
      config.headers.set(
        'user-context',
        btoa(JSON.stringify(getUserContext()))
      );
      return config;
    } catch (e) {
      return config;
    }
  },
  error => Promise.reject(error)
);
